import config from "../config"
const baseUrl = config.base_url + "container_phenology_trigger/"
export default {
    page: {
        url: baseUrl + "page/{limit}/{page}",
        type: "get",
    },
    listByPhenology: {
        url: baseUrl + "list_by_phenology",
        type: "get",
    },
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    update: {
        url: baseUrl + "update",
        type: "post",
    },
    remove: {
        url: baseUrl + "delete",
        type: "get",
    },
    get: {
        url: baseUrl + "get",
        type: "get",
    }
}
